export var Errors;
(function (Errors) {
    Errors["CREATION_CANCELLED"] = "creation of credential cancelled";
    Errors["CREATION_FAILED"] = "creation of credential failed";
    Errors["CREATION_DECODING_FAILED"] = "creation decoding failed";
    Errors["CREATION_PARSING_FAILED"] = "creation parsing failed";
    Errors["ASSERTION_CANCELLED"] = "assertion of credential cancelled";
    Errors["ASSERTION_FAILED"] = "assertion of credential failed";
    Errors["ASSERTION_PARSING_FAILED"] = "assertion parsing failed";
})(Errors || (Errors = {}));
